// extracted by mini-css-extract-plugin
module.exports = {"mobile":"Asset_mobile__EUw_K","desktop":"Asset_desktop__aa6Nf"};